type Tag = string | { name: string; [key: string]: any }

// Dynamic components in nuxt 3 have to be passed as a resolved component object
// https://nuxt.com/docs/guide/directory-structure/components#dynamic-components
export const isNuxtLink = (tag: Tag): boolean => {
  return (
    tag === 'nuxt-link' || (typeof tag === 'object' && tag.name === 'NuxtLink')
  )
}

/**
 * Check if a tag is clickable. We allow div and span for fake clickable tags,
 * or object for resolved components.
 * @param tag The tag to check
 * @returns {boolean} Whether the tag is clickable
 */
export const clickableTag = (tag: Tag): boolean => {
  return (
    isNuxtLink(tag) ||
    (typeof tag === 'string' &&
      ['span', 'div', 'a', 'button', 'router-link'].includes(tag))
  )
}
